import React from 'react';

export interface CheckboxProps {
    name?: string;
    disabled?: boolean;
    error?: boolean;
    label?: string;
    checked: boolean;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    value?: string;
    labelClassNames?: string;
    textClassNames?: string;
    id?: string;
}

const Checkbox: React.FC<CheckboxProps> = (props) => {
    const { name = '', error = false, disabled = false, labelClassNames = '', textClassNames = '', id = '' } = props;

    const classNamesLabel = `flex items-center cursor-pointer `;
    const classNamesSpan = `ml-[8px] `;

    const defaultCheckboxClassNames = 'checkbox checkbox-sm accent-primary cursor-pointer';

    // Error
    let errorClassNames = '';
    let spanErrorClassNames = '';
    if (error) {
        errorClassNames =
            'checkbox-error focus:border-red-500 focus:shadow-[inset_0_1px_1px_rgba(0,0,0,0.08),0_0_8px_rgba(255,99,71,0.6)]';
        spanErrorClassNames = 'text-red-500';
    }
    const checkboxClassNames = [defaultCheckboxClassNames, errorClassNames].join(' ');
    const combinedLabelClassNames = [classNamesSpan, textClassNames, spanErrorClassNames].join('');

    return (
        <label className={classNamesLabel + labelClassNames}>
            <input
                type="checkbox"
                className={checkboxClassNames}
                checked={props.checked}
                onChange={props.onChange}
                value={props.value}
                name={name}
                disabled={disabled}
                id={id}
            />
            {props.label && <span className={combinedLabelClassNames}>{props.label}</span>}
        </label>
    );
};

export default Checkbox;
